module.exports = __webpack_public_path__ + "static/media/3.0cdeb40d.jpg";